// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1tjq10s3 span{color:var(--ds-text,#42526e)}\n._1tjq15cr span{color:var(--ds-text-inverse,#fff)}\n._1tjqal3n span{color:var(--ds-text-warning-inverse,#172b4d)}", ""]);
// Exports
module.exports = exports;
